import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Brain, Menu, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useBrainStore } from "@/stores/brainStore";
import { MobileSidebar } from "./MobileSidebar";
import { OrganizationSwitcher } from "./OrganizationSwitcher";
import { UserMenu } from "./UserMenu";
import { LocaleToggle } from "./LocaleToggle";
import { HelpCenter } from "@/features/help/HelpCenter";

export function Header() {
  const { t } = useTranslation();
  const openBrain = useBrainStore((s) => s.open);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <>
      <header className="flex h-16 items-center justify-between border-b border-border bg-card px-6">
        <div className="flex items-center gap-3">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => setMobileNavOpen(true)}
            className="lg:hidden min-h-[44px] min-w-[44px]"
            aria-label={t("nav.openMenu")}
          >
            <Menu className="h-5 w-5" />
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => openBrain()}
            className="lg:hidden min-h-[44px] min-w-[44px]"
            aria-label={t("nav.brain")}
          >
            <Brain className="h-5 w-5" />
          </Button>
          <OrganizationSwitcher />
        </div>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => setHelpOpen(true)}
            className="min-h-[44px] min-w-[44px]"
            aria-label={t("nav.help", "Help")}
          >
            <HelpCircle className="h-5 w-5" />
          </Button>
          <LocaleToggle />
          <UserMenu />
        </div>
      </header>

      <MobileSidebar
        open={mobileNavOpen}
        onOpenChange={setMobileNavOpen}
      />
      <HelpCenter open={helpOpen} onOpenChange={setHelpOpen} persona="manager" />
    </>
  );
}